"use client";
import React, { ReactNode } from "react";
import CustomModal from "./CustomModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { closeVideoMPModal } from "@/redux/features/videoMPModal/videoMPModalSlice";

export default function VideoMediaPlayerModal() {
  const dispatch = useDispatch();

  const { isOpen, video } = useSelector((state: RootState) => state.videoMPModal);
  
  return (
    <>
      <CustomModal
        isOpen={isOpen}
        onClose={() => dispatch(closeVideoMPModal())}
        isBlurOverlay
        showCloseButton={false}
        maxSize="max-w-[750px] aspect-video"
        className="rounded-t-2xl! sm:rounded-4xl! h-56 sm:h-full overflow-hidden"
      >
        {video ? (
          <video src={video} controls autoPlay playsInline muted className="w-full h-full object-cover rounded-t-1.5xl sm:rounded-3xl" />
        ) : (
          <div className="flex items-center justify-center w-full m-auto bg-black text-white">No video available</div>
        )}
      </CustomModal>
    </>
  );
}
